import { createFileRoute } from "@tanstack/react-router";
import { FallbackEmpty } from "~/components/FallbackEmpty";
import { useFeatureFlags } from "~/hooks/useFeatureFlags";
import { PropertyPage } from "./-components/PropertyPage";
import { PropertyRouteError } from "./-components/PropertyRouteError";
import {
  propertyParamsSchema,
  resolvedPropertySearchSchema,
} from "./-propertyTabs";

export const Route = createFileRoute("/(restricted)/ejendomme/bfe/$bfeNumber")({
  component: RouteComponent,
  validateSearch: resolvedPropertySearchSchema,
  params: { parse: (params) => propertyParamsSchema.parse(params) },
  errorComponent: PropertyRouteError,
  loader: async ({ context: { i18n } }) => {
    await i18n.loadNamespaces(["properties", "restrictions", "sales-prices"]);
    return { meta: { title: i18n.t("properties:meta.title") } };
  },
  head: (context) => ({ meta: [{ title: context.loaderData?.meta.title }] }),
});

function RouteComponent() {
  const { bfeNumber } = Route.useParams();
  const { accessAddressId, placeId } = Route.useSearch();
  const { flags } = useFeatureFlags();

  if (!flags.PROPERTIES_ENABLED) return <FallbackEmpty />;

  return (
    <div className="w-full min-w-0 px-4 md:px-8">
      <PropertyPage
        key={bfeNumber}
        bfeNumber={bfeNumber}
        streetNumberId={accessAddressId}
        placeId={placeId}
      />
    </div>
  );
}
